import axios from "../http";

let module = "/clew";

function addClew(data) {
    return axios.post(module+"/add", data);
}

function updateClew(data) {
    return axios.put(module, data);
}

function allClew(data) {
    return axios.post(module+"/all", data);
}

function queryNoFollowedClew(data) {
    return axios.post(module+"/stayFollowed", data);
}

function queryTreeNoFollowedClew(data) {
    return axios.post(module+"/treeNoFollowed", data);
}

function queryStayAuditClew(data) {
    return axios.post(module+"/stayAudit", data);
}

function queryHandClew(data) {
    return axios.post(module+"/hand", data);
}

function queryDetail(data) {
    return axios.get(module+"/detail/"+data.id);
}

function updateRemarksByClewId(data) {
    return axios.put(module+"/remarks",data);
}

function updateIntentionByClewId(data) {
    return axios.put(module+"/intention",data);
}


export default {
    addClew,
    updateClew,
    allClew,
    queryNoFollowedClew,
    queryTreeNoFollowedClew,
    queryStayAuditClew,
    queryHandClew,
    queryDetail,
    updateRemarksByClewId,
    updateIntentionByClewId,
}
